module.exports = __webpack_public_path__ + "static/media/ABBA_Dataset.fc5969d4.zip";